import SeparateLine from '@/shared/Forms/SeparateLine'
import css from './EditAlarmSituationsSidePageContent.module.css'
import useHttpLoader from '@/shared/hooks/useHttpLoader.ts'
import useStateWithChange from '@/shared/hooks/useStateWithChange.ts'
import Button from '@/shared/Buttons/Button'
import alarmSituationApi from '@/pages/Processes/AlarmSituations/alarmSituations.api.ts'
import { IAlarmSituation } from '@/pages/Processes/AlarmSituations/alarmSituations.types.ts'
import alarmSituationsEvents from '@/pages/Processes/AlarmSituations/events/alarmSituations.events.ts'
import AlarmSituationFormFields from '../../AlarmSituationFormFields'
import alarmSituationUtils from '@/pages/Processes/AlarmSituations/alarmSituations.utils.ts'

interface IProps {
  onCancel: () => void
  alarmSituation: IAlarmSituation
}

const EditAlarmSituationsSidePageContent = (props: IProps) => {
  const { wait, loading } = useHttpLoader()
  const [alarmSituation, _, handleChange] = useStateWithChange<IAlarmSituation>(props.alarmSituation)

  const handleUpdateParameter = () => {
    wait(alarmSituationApi.updateAlarmSituation(alarmSituation), (resp) => {
      if (resp.status === 'success') {
        alarmSituationsEvents.updated(resp.body)
        props.onCancel()
      }
    })
  }

  return (
    <div className="flex-lines gap16" style={{ height: '100%' }}>
      <h4 className="text-heading-4">Редактирование триггера сигнальной ситуации</h4>
      <SeparateLine />
      <div className={css.wrapperContent}>
        <AlarmSituationFormFields alarmSituation={alarmSituation} handleChange={handleChange} />
        <div className={css.actions}>
          <Button
            text="Сохранить"
            size="default"
            type="primary"
            loading={loading}
            disabled={!alarmSituationUtils.isCorrectFormAlarmSituationFields(alarmSituation)}
            onClick={handleUpdateParameter}
          />

          <Button size="default" type="default" text="Отменить" onClick={props.onCancel} disabled={loading} />
        </div>
      </div>
    </div>
  )
}

export default EditAlarmSituationsSidePageContent
